import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=5afae974&scoped=true&"
import script from "./HospitalList.vue?vue&type=script&lang=js&"
export * from "./HospitalList.vue?vue&type=script&lang=js&"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=5afae974&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afae974",
  null
  
)

export default component.exports